import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ProteccionConsumidorService } from '../services/proteccion-consumidor.service';
import { TramiteSicProteccionConsumidorDto } from '../../../../../dto/tramites/tramite-sic-proteccion-consumidor.dto';
import { AnexoPrecargaResponseDto } from '../../../../../dto/anexo/anexo-tramite.dto';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from "../../../../../constants/constants";
import { ArchivoItemDto } from '../../../../util/archivos-tramite/dto/ArchivoItemDto';
import { CargueArchivosTramiteService } from "../../../../util/archivos-tramite/services/cargue-archivos-tramite.service";

@Component({
  selector: 'app-pruebas',
  templateUrl: './pruebas.component.html',
  styleUrl: './pruebas.component.scss',
})
export class PruebasComponent implements OnChanges {
  @Input() idTramite = 0;
  @Input() tramiteSic?: TramiteSicProteccionConsumidorDto;
  @Input() archivosPreCargados?: AnexoPrecargaResponseDto[];
  @Input() nombreCortoLimpioTramite?: string = undefined
  @Output() continuar = new EventEmitter<{
    subio: boolean;
    event: Event;
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    subio: boolean;
    event: Event;
  }>();
  @Output() volver = new EventEmitter<number>();
  enviar = false;
  subio = false;
  event!: Event;
  // Multilenguaje
  proconText: any = {};
  comunText: any = {};

  // Archivos
  jsonRegla: any = {};
  reglaPaso1: any = {};
  reglaPaso3: any = {};
  reglaPaso4: any = {};
  pesoArchivos1MB: string = '0.00';
  pesoArchivos3MB: string = '0.00';
  pesoArchivos4MB: string = '0.00';
  pesoArchivos7MB: string = '0.00';
  mostrarArchivos: boolean = false;
  constructor(
    private readonly proteccionConsumidorService: ProteccionConsumidorService,
    private readonly translate: TranslateService,
    private readonly cargueArchivosTramiteService: CargueArchivosTramiteService,
  ) {
    sessionStorage.removeItem('siguiente');
    sessionStorage.setItem(Constants.ARCHIVOS_SIC_PROCON_PASO_SIETE, 'false');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['idTramite'] &&
      changes['idTramite'].currentValue !== undefined
    ) {
      this.idTramite = changes['idTramite'].currentValue;
    }
    const tramite: TramiteSicProteccionConsumidorDto =
      changes['tramiteSic'].currentValue;
    this.proteccionConsumidorService
      .cargarTramitePendiente(tramite.id!)
      .subscribe((resp: TramiteSicProteccionConsumidorDto) => {
        if (this.tramiteSic) {
          this.tramiteSic.anexos = resp.anexos;
          const codigo = this.tramiteSic?.tipoProteccion?.tipoProteccion?.codigo
          if (this.tramiteSic.anexos && codigo) {
            // Se valida si el tipo de protección almacenado es: Protección contractual
            if (codigo == 'PR_PC') {
              // Se eliminan los archivos de publicidad engañosa, porque ya no aplica para este tipo de protección
              this.tramiteSic.anexos = this.tramiteSic.anexos.filter(item =>
                item.tipoAnexoTipoTramite.nombreAnexo !== 'Publicidad_Engañosa'
              );
            }
            // Se valida si el tipo de protección almacenado es: Reconocimiento y pago
            // de los perjuicios causados como consecuencia de publicidad e información engañosa
            if (codigo == 'PR_PIE') {
              // Se eliminan los archivos de contrato, porque ya no aplica para este tipo de protección
              this.tramiteSic.anexos = this.tramiteSic.anexos.filter(item =>
                item.tipoAnexoTipoTramite.nombreAnexo !== 'Contrato');
            }
          }
          let paso = Number(sessionStorage.getItem(Constants.PASOS));
          if (paso == 7) {
            this.mostrarArchivos = true;
            setTimeout(() => {
              this.consultarTramitePorID(tramite.id!);
            }, 3000);
          }
        }
      });
    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.proconText[key] = text[key];
      }
    });

    this.jsonRegla = {
      otrasPruebas: 'SI',
    };
    this.reglaPaso1 = this.validarReglaRequerido(1);
    this.reglaPaso3 = this.validarReglaRequerido(3);
    this.reglaPaso4 = this.validarReglaRequerido(4);
  }

  consultarTramitePorID(id: number) {
    this.proteccionConsumidorService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteSicProteccionConsumidorDto) => {
        if (resp.anexos) {
          if (this.mostrarArchivos) {
            this.mostrarArchivos = false;
            setTimeout(() => {
              this.mostrarArchivos = true;
            }, 10)
          }
        }

      });
  }

  validarReglaRequerido(paso: number): any {
    switch (paso) {
      case 1:
        if (this.tramiteSic?.apoderado?.id) {
          return { apoderado: 'SI' }
        }
        return {}
      case 3:
        if (this.tramiteSic?.tipoReclamacion?.codigo == Constants.RECLAMACION_ESCRITA) {
          const regla = {
            tipoReclamacion: this.tramiteSic?.tipoReclamacion?.codigo,
            recibioRespuesta: this.tramiteSic?.recibioRespuesta ? 'S' : 'N'
          }
          return regla;
        }
        if (this.tramiteSic?.tipoReclamacion?.codigo == Constants.RECLAMACION_VERBAL) {
          const regla = {
            tipoReclamacion: this.tramiteSic?.tipoReclamacion?.codigo,
            expidioConstancia: this.tramiteSic?.expidioConstancia
          }
          return regla;
        }
        return {}
      case 4:
        if (this.tramiteSic?.tipoProteccion?.tipoProteccion?.codigo === 'PR_PIE') {
          const regla = {
            tipoProteccion: 'PR_PIE',
            tienePruebas:
              Number((this.tramiteSic.tipoProteccion as { tienePruebas: string }).tienePruebas) === 1 ? 'SI' : 'NO',
          }
          return regla
        }
        if (this.tramiteSic?.tipoProteccion?.tipoProteccion?.codigo === 'PR_PC') {
          const regla = {
            tipoProteccion: 'PR_PC',
          }
          return regla
        }
        return {}
      default: return {}
    }
  }

  archivosFiltrados(orden: number): AnexoPrecargaResponseDto[] {
    return (
      this.tramiteSic?.anexos?.filter(
        item => item.tipoAnexoTipoTramite?.orden === orden
      ) ?? []
    );
  }

  getArchivosByPaso(archivos: ArchivoItemDto[], paso: number) {
    let total = 0;

    archivos.forEach(element => {
      element.files.forEach(item => {
        total = total + item.size;
      })
    });
    switch (paso) {
      case 1:
        this.pesoArchivos1MB = (total / (1024 * 1024)).toFixed(2);
        break;
      case 3:
        this.pesoArchivos3MB = (total / (1024 * 1024)).toFixed(2);
        break;
      case 4:
        this.pesoArchivos4MB = (total / (1024 * 1024)).toFixed(2);
        break;
      case 7:
        this.pesoArchivos7MB = (total / (1024 * 1024)).toFixed(2);
        sessionStorage.setItem(Constants.ARCHIVOS_SIC_PROCON_PASO_SIETE, 'true');
        break;
    }
  }

  get pesoArchivosPaso1(): string {
    return this.pesoArchivos1MB;
  }
  get pesoArchivosPaso3(): string {
    return this.pesoArchivos3MB;
  }
  get pesoArchivosPaso4(): string {
    return this.pesoArchivos4MB;
  }
  get pesoArchivosPaso7(): string {
    return this.pesoArchivos7MB;
  }

  subir(subio: boolean, paso: number) {
    this.enviar = false;
    this.subio = subio;
    if (this.subio) {
      const tramite: TramiteSicProteccionConsumidorDto = {
        id: this.idTramite,
      };
      this.proteccionConsumidorService.crear(tramite, false).subscribe();
      const siguiente = sessionStorage.getItem(
        'siguiente'
      );
      if (siguiente && paso === 7) {
        this.continuar.emit({ subio: subio, event: this.event });
      }
    }
  }

  siguiente(e: Event, guardarSinEnviar: boolean) {
    let paso = JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(8));
    }
    if (!guardarSinEnviar) {
      this.enviar = true;
      setTimeout(() => {
        this.event = e;
        sessionStorage.setItem(
          'siguiente',
          'siguiente'
        );
      }, 600);

    } else {
      this.enviar = true;
      setTimeout(() => {
        this.guardarSinEnviar.emit({ subio: false, event: e });
      }, 600);

    }
  }

  anterior() {
    let paso = JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }
    this.volver.emit(6);
  }

  bytesToKb(bytes: number): number {
    const kb = bytes / 1024;
    return Number(kb.toFixed(2));
  }

  protected readonly Constants = Constants;
  protected readonly JSON = JSON;
}
